/*
  Load-more handler for collection + blog grids.

  Vanilla JS (post-jQuery). The "Load More" button at the bottom of the
  grid fetches the next paginated page on click, appends the new items
  into the existing grid, and removes itself when the last page is
  reached.

  Page state lives in hidden inputs alongside the grid:
    • [data-total-pages]   — total page count for this collection
    • [data-current-page]  — current page (1-based, mutated client-side)
    • [data-next-url]      — `?page=N` URL template for the next fetch

  External dep: `colorSwatches()` (defined in product-card.js) — called
  after each batch is appended so new cards pick up their swatch JS.

  Infinite-scroll has been removed from this theme; the previous
  IntersectionObserver fallback that auto-loaded the next page when a
  spinner scrolled into view is gone.
*/

(function () {
  function getInputValue(selector) {
    var el = document.querySelector(selector);
    return el ? el.value : null;
  }

  function loadItems(button) {
    var totalPagesRaw = getInputValue('[data-total-pages]');
    var currentPageRaw = getInputValue('[data-current-page]');
    var nextUrlRaw = getInputValue('[data-next-url]');

    if (totalPagesRaw === null || currentPageRaw === null || nextUrlRaw === null) {
      return;
    }

    var totalPages = parseInt(totalPagesRaw, 10);
    var currentPage = parseInt(currentPageRaw, 10) + 1;

    var nextUrl = nextUrlRaw.replace(/page=[0-9]+/, 'page=' + currentPage);

    var currentPageInput = document.querySelector('[data-current-page]');
    if (currentPageInput) currentPageInput.value = currentPage;

    button.setAttribute('disabled', '');
    button.classList.add('loading');

    fetch(nextUrl, { method: 'GET', headers: { 'Accept': 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response not ok');
        return response.text();
      })
      .then(function (responseHTML) {
        // Parse the returned page and pull the new grid items out of
        // its `.load-more-grid` container, then append into the live
        // grid on the current page.
        var parser = new DOMParser();
        var doc = parser.parseFromString(responseHTML, 'text/html');
        var incomingGrid = doc.querySelector('.load-more-grid');
        var liveGrid = document.querySelector('.load-more-grid');
        if (incomingGrid && liveGrid) {
          // Append each child individually so existing nodes (and any
          // delegated handlers attached to them) are preserved.
          while (incomingGrid.firstChild) {
            liveGrid.appendChild(incomingGrid.firstChild);
          }
        }
        if (typeof colorSwatches === 'function') colorSwatches();
      })
      .catch(function () {
        // Silent fail — keep the button enabled so the user can retry.
      })
      .finally(function () {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage >= totalPages) {
          button.remove();
        }
      });
  }

  function loadMore() {
    document.querySelectorAll('.js-load-more').forEach(function (button) {
      button.addEventListener('click', function () {
        loadItems(button);
      });
    });
  }

  loadMore();
})();
